// extracted by mini-css-extract-plugin
module.exports = {"discoverContainer":"DiscoverElement_discoverContainer__b2zQ6","discoverImg":"DiscoverElement_discoverImg__3VLku"};